import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import MainLayout from "../../layouts/mainLayout";
import BookingRequestService from "../../services/bookingRequestService";
import PayloadUpdater from "../../utils/payloadUpdater";
import Select from "react-select";
import FileInput from "../../components/fileInput";
import Spinner from "../../utils/spinner";
import {
  Validator,
  ValidateGroup,
  ClearValidator,
} from "../../components/validator";
import toastr from "../../utils/toastr";
import VoyageService from "../../services/voyageService";
import ReactTooltip from "react-tooltip";
import CustomModal from "../../utils/customModal";
import { toReadableDate } from "../../utils/utilityFunctions";
import { forEach } from "lodash";

export default function UploadCargoEvidence() {
  const params = useParams();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({});
  const [saving, setSaving] = useState(false);
  const [voyage, setVoyage] = useState({});
  const [bulkCargo, setBulkCargo] = useState([]);
  const [deckCargo, setDeckCargo] = useState([]);
  const [bulkCargoId, setBulkCargoId] = useState([]);
  const [deckCargoId, setDeckCargoId] = useState([]);
  const [bulkSaving, setBulkSaving] = useState(false);
  const [deckSaving, setDeckSaving] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [deckLoading, setDeckLoading] = useState(false);

  const addPayload = new PayloadUpdater({
    payload: payload,
    setPayload: setPayload,
  }).update;
  const validationGroup = "uploadEvidenceOfLoadedCargo";

  useEffect(async () => {
    await init();
  }, []);

  const init = async () => {
    setLoading(true);
    let _voyage = await VoyageService.get(params.voyagePlanningId);
    setVoyage(_voyage || []);

    if (_voyage?.BulkCargos) {
      let _bCargo = _voyage.BulkCargos?.map((l) => ({
        ...l,
      }));
      setBulkCargo(_bCargo || []);
    }

    if (_voyage?.DeckCargos) {
      let _dCargo = _voyage.DeckCargos?.map((l) => ({
        ...l,
      }));
      setDeckCargo(_dCargo || []);
    }

    setLoading(false);
  };

  const uploadBulkProof = async () => {
    const _payload = { ...payload };

    if (!_payload.cargoDetailId) {
      toastr("error", "Select a bulk cargo item");
      return;
    }

    if (!_payload.base64Evidence) {
      toastr("error", "Select a file to upload");
      return;
    }

    setBulkSaving(true);

    delete _payload.fileName;
    const request = await VoyageService.uploadBulkCargoEvidence(_payload);
    if (request) {
      setPayload({});
      toastr("success", "Bulk cargo evidence uploaded");
      await init();
    } else {
      toastr("error", "Bulk cargo evidence not uploaded");
      setLoading(false);
      return;
    }
    setBulkSaving(false);
  };

  const uploadDeckProof = async () => {
    const _payload = { ...payload };

    if (!_payload.cargoDetailId) {
      toastr("error", "Select a deck cargo item");
      return;
    }

    if (!_payload.base64Evidence) {
      toastr("error", "Select a file to upload");
      return;
    }

    setDeckSaving(true);

    delete _payload.fileName;
    const request = await VoyageService.uploadDeckCargoEvidence(_payload);
    if (request) {
      setPayload({});
      toastr("success", "Deck cargo evidence uploaded");
      await init();
    } else {
      toastr("error", "Deck cargo evidence not uploaded");
      setLoading(false);
      return;
    }
    setDeckSaving(false);
  };

  const pageActions = (
    <div className="toggle-wrap nk-block-tools-toggle">
      <a
        href="#"
        className="btn btn-icon btn-trigger toggle-expand mr-n1"
        data-target="pageMenu"
      >
        <em className="icon ni ni-menu-alt-r" />
      </a>
      <div className="toggle-expand-content" data-content="pageMenu">
        <ul className="nk-block-tools g-3">
          <li>
            <button
              onClick={() => window.history.back()}
              className="btn btn-white btn-outline-light"
            >
              <em className="icon ni ni-arrow-left" />
              <span>Return to Previous Page</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );

  return redirectUrl ? (
    <Navigate to={redirectUrl} replace={true} />
  ) : (
    <MainLayout
      title="Upload Cargo Evidence"
      loading={loading}
      pageActions={pageActions}
    >
      {loading ? (
        <div className="w-100 text-center center my-5 py-5">
          <Spinner />
        </div>
      ) : (
        <form>
          <div className="card-inner">
            <div className="row">
              <div className="col-12">
                <p>
                  <span className="preview-title-lg overline-title">
                    Proof of Loaded Bulk Cargo
                  </span>{" "}
                </p>
              </div>

              <div className="col-md-4">
                <div className="form-group" style={{ zIndex: "50" }}>
                  <label className="form-label small">Bulk Cargo(s)</label>
                  <div className="form-control-wrap">
                    <Select
                      onChange={(e) => {
                        addPayload("cargoDetailId", e.value);
                        // handleBulkTypeChange(option);
                      }}
                      // isMulti={true}
                      value={bulkCargo
                        ?.map((c) => ({
                          ...c,
                          label: c.BookingReference + " - " + c.ProductName,
                          value: c.BulkCargoDetailId,
                        }))
                        ?.find((a) => a.value == payload?.BulkCargoDetailId)}
                      options={bulkCargo?.map((c) => ({
                        ...c,
                        label: c.BookingReference + " - " + c.ProductName,
                        value: c.BulkCargoDetailId,
                      }))}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group" style={{ zIndex: "10" }}>
                  <label className="form-label small">Select Evidence</label>
                  <div className="form-control-wrap">
                    <FileInput
                      onChange={(file) => {
                        addPayload(
                          ["base64Evidence", "fileName"],
                          [file.base64, `${file.name}`]
                        );
                      }}
                      fileValue={{
                        name: payload.fileName,
                        size: payload.base64Evidence?.length || 0,
                        fileContent: payload.base64Evidence,
                      }}
                    />
                  </div>
                </div>
              </div>

              {bulkSaving && (
                <button type="button" className="btn btn-md btn-link mt-4">
                  <Spinner size="1.5" />
                </button>
              )}

              {!bulkSaving && (
                <button
                  type="button"
                  className="btn btn-md btn-dim btn-secondary btn-dark mt-4"
                  onClick={uploadBulkProof}
                >
                  Upload Evidence
                </button>
              )}
            </div>
          </div>

          <div className="card-inner">
            <div className="row">
              <div className="col-12">
                <p>
                  <span className="preview-title-lg overline-title">
                    Proof of Loaded Deck Cargo
                  </span>{" "}
                </p>
              </div>

              <div className="col-md-4">
                <div className="form-group" style={{ zIndex: "20" }}>
                  <label className="form-label small">Deck Cargo(s)</label>
                  <div className="form-control-wrap">
                    <Select
                      onChange={(e) => {
                        addPayload("cargoDetailId", e.value);
                        // handleDeckTypeChange(option);
                      }}
                      // isMulti={true}
                      value={deckCargo
                        ?.map((c) => ({
                          ...c,
                          label:
                            c.BookingReference + " - " + c.DescriptionOfGoods,
                          value: c.DeckCargoDetailId,
                        }))
                        ?.find((a) => a.value == payload?.DeckCargoDetailId)}
                      options={deckCargo?.map((c) => ({
                        ...c,
                        label:
                          c.BookingReference + " - " + c.DescriptionOfGoods,
                        value: c.DeckCargoDetailId,
                      }))}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group" style={{ zIndex: "10" }}>
                  <label className="form-label small">Select Evidence</label>
                  <div className="form-control-wrap">
                    <FileInput
                      onChange={(file) => {
                        addPayload(
                          ["base64Evidence", "fileName"],
                          [file.base64, `${file.name}`]
                        );
                      }}
                      fileValue={{
                        name: payload.fileName,
                        size: payload.base64Evidence?.length || 0,
                        fileContent: payload.base64Evidence,
                      }}
                    />
                  </div>
                </div>
              </div>

              {deckSaving && (
                <button type="button" className="btn btn-md btn-link mt-4">
                  <Spinner size="1.5" />
                </button>
              )}

              {!deckSaving && (
                <button
                  type="button"
                  className="btn btn-md btn-dim btn-secondary btn-dark mt-4"
                  onClick={uploadDeckProof}
                >
                  Upload Evidence
                </button>
              )}
            </div>
          </div>
        </form>
      )}

      <hr className="preview-hr" style={{ visibility: "hidden" }} />
    </MainLayout>
  );
}
